export const initHideRecipeModules = () => {
  const applyFilter = document.querySelector(
    '.dp-dfg-filter-actions .et_pb_button_wrapper .dp-dfg-filter-trigger-button',
  );
  const recipe = document.querySelector('.et_pb_section.recipe');
  const sausages = document.querySelector('.et_pb_section.craft-sausages');

  if (applyFilter && recipe && sausages) {
    applyFilter.addEventListener('click', () => {
      recipe.style.display = 'none';
      sausages.style.display = 'none';
    });
  }
};
